import {
  EXTERNAL_APP_HOSTING_LINKS,
  INTERNAL_APP_HOSTING_LINKS,
} from '../constants';
import { HostingLocation } from '../enums';

export const getHostingLocationFromAppUrls = (
  urls: AppUrl[]
): HostingLocation => {
  if (urls.length == 0) {
    return HostingLocation.PLATFORM;
  }

  const possibleAppUrls = EXTERNAL_APP_HOSTING_LINKS.concat(
    INTERNAL_APP_HOSTING_LINKS
  );
  const extAppUrls = urls.filter((url) =>
    possibleAppUrls.find((extLink) => extLink === url.name)
  );

  if (extAppUrls.length === 0) {
    return HostingLocation.PLATFORM;
  }

  let predictedHostingLoc = HostingLocation.EXTERNAL;
  EXTERNAL_APP_HOSTING_LINKS.forEach((extLink) => {
    if (!extAppUrls.find((url) => extLink === url.name)) {
      predictedHostingLoc = HostingLocation.PLATFORM;
    }
  });

  return predictedHostingLoc;
};

export const getAppUrlsUpdatedWithFormHostingLinks = (
  urls: AppUrl[] | undefined,
  hostingLinks: string[],
  updatedUrls: { [key: string]: string | undefined }
): AppUrl[] => {
  if (!urls) {
    return [];
  }

  const appUrls = urls.map((url) => {
    return { ...url };
  });

  hostingLinks.forEach((hostingLink) => {
    const formLinkVal: string = updatedUrls[hostingLink] || '';
    const foundAtIndex = appUrls.findIndex(
      (curUrl) => curUrl.name === hostingLink
    );
    if (foundAtIndex > -1) {
      if (formLinkVal) {
        appUrls[foundAtIndex].url = formLinkVal;
      } else {
        appUrls.splice(foundAtIndex, 1);
      }
    } else {
      if (formLinkVal) {
        appUrls.push({ name: hostingLink, url: formLinkVal });
      }
    }
  });

  return appUrls;
};

export const getFormHostingLinksFromAppUrls = (
  appUrls: AppUrl[],
  hostingLinks: string[],
  prepend?: string
): { [key: string]: string } => {
  const links = appUrls.reduce((accumulator, url) => {
    const link = hostingLinks.find((link) => link === url.name);
    if (link) {
      accumulator[link] = `${prepend || ''}${url.url}`;
    }

    return accumulator;
  }, {});

  return links;
};

export const isAppLinkCompatibleWithHostingChoice = (
  link: AppUrl,
  hostingChoice: HostingLocation
) => {
  const isPlatformLinkMatch =
    hostingChoice === HostingLocation.PLATFORM &&
    INTERNAL_APP_HOSTING_LINKS.map((link) => link.toString()).includes(
      link.name
    );
  const isExternalLinkMatch =
    hostingChoice === HostingLocation.EXTERNAL &&
    EXTERNAL_APP_HOSTING_LINKS.map((link) => link.toString()).includes(
      link.name
    );

  return isPlatformLinkMatch || isExternalLinkMatch;
};
